import { render, staticRenderFns } from "./Gems.vue?vue&type=template&id=68086cda&"
import script from "./Gems.vue?vue&type=script&lang=js&"
export * from "./Gems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports